import React from 'react'

const Button = ({ label, icon: Icon, onClick, disabled, className = '', type = 'button', ...props }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium
        ${disabled 
          ? 'bg-gray-200 text-gray-800 hover:bg-gray-300 cursor-not-allowed' 
          : 'bg-blue-600 text-white shadow-md'
        }
        ${className}`}
      {...props}
    >
      {Icon && <Icon className="w-5 h-5" />}
      {label}
    </button>
  )
}

export default Button 